var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashOnWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 555.97 375.12",
    id: "CashOnWallet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 459.11,
    x2: 423.07,
    y1: 109.26,
    y2: 402.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 482.48,
    x2: 446.44,
    y1: 108.04,
    y2: 401.61,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 224.65,
    x2: 152.01,
    y1: 195.93,
    y2: 175.66,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 208.45,
    x2: 301.92,
    y1: 206.06,
    y2: 123.84,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 274.54,
    x2: 295.94,
    y1: 151.95,
    y2: 313.57,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 333.6,
    x2: 343.2,
    y1: 106.21,
    y2: 289.27,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 426.96,
    x2: 323.34,
    y1: 158.42,
    y2: 362.27,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 358.85,
    x2: 371.62,
    y1: 183.82,
    y2: 183.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad59d4",
    className: "stopColorecc4d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#d8a353",
    className: "stopColorefd4d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2e2c9",
    className: "stopColorf2eac9 svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 422.34,
    x2: 433.37,
    y1: 171.55,
    y2: 171.55,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 253.32,
    x2: 230.94,
    y1: 168.16,
    y2: 158.45,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 214.73,
    x2: 241.76,
    y1: 199.49,
    y2: 180.91,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 272,
    x2: 283.97,
    y1: 178.66,
    y2: 178.66,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 197.67,
    x2: 197.44,
    y1: 231.09,
    y2: 266.18,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 391.63,
    x2: 390.7,
    y1: 253.79,
    y2: 253.74,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 199.61,
    x2: 199.05,
    y1: 218.03,
    y2: 305.33,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 265.06,
    x2: -453.48,
    y1: 340.8,
    y2: 356.57,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 237.14,
    x2: 245.58,
    y1: 187.14,
    y2: 266.54,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 399.43,
    x2: 269.43,
    y1: 243.94,
    y2: 402.73,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 467.21,
    x2: 271.24,
    y1: 171.35,
    y2: 566.66,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 389.33,
    x2: 387.93,
    y1: 252.16,
    y2: 254.5,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 287.8,
    x2: 192.65,
    y1: 176.2,
    y2: 368.15,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 254.78,
    x2: 258.73,
    y1: 213.34,
    y2: 240.37,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 505.58,
    x2: 374.19,
    y1: 224.77,
    y2: 228.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ffffff",
    stopOpacity: 0.03,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ffffff",
    stopOpacity: 0.11,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ffffff",
    stopOpacity: 0.25,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ffffff",
    stopOpacity: 0.43,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ffffff",
    stopOpacity: 0.67,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ffffff",
    stopOpacity: 0.96,
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 451.81,
    x2: 356.07,
    y1: 306.58,
    y2: 415.83,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 461.1,
    x2: 383.67,
    y1: 319.64,
    y2: 399.04,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 231.85,
    x2: 274.09,
    y1: 220.99,
    y2: 220.99,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 398.55,
    x2: 416.42,
    y1: 192.98,
    y2: 192.98,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 227.4,
    x2: 206.38,
    y1: 172.62,
    y2: 188.15,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 231.25,
    x2: 218.02,
    y1: 152.64,
    y2: 164.89,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 180.21,
    x2: 518.92,
    y1: 305.72,
    y2: 692.58,
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M483.7 413c10.39-2.52 21.39-5.78 28.23-14 18.06-21.73-5.47-59.18 11.78-81.55 3.13-4.05 7.38-7.18 10.24-11.42 9.91-14.69-.46-34-9.42-49.29a311.52 311.52 0 0 1-29.48-67.63c-4.84-16.07-8.71-33.2-19.72-45.87-15.17-17.45-40.42-22.27-63.53-21.54-15.3.48-30.93 2.87-45.71-1.11C343 114.33 284 14.89 169.61 101.76c-8.12 6.17-17.56 10.58-24.78 17.77-8 8-14.17 18-23.39 24.6-8.82 6.32-19.68 9-29.44 13.69-34.8 16.82-51.57 58.45-51.46 97.09.06 20.53 3.83 41.9-3.64 61-2.48 6.33-6.17 12.36-6.83 19.12-1.29 13.29 9.17 24.49 18.87 33.65 20.37 19.24 41.6 38.73 67.76 48.78 25.47 9.78 53.5 9.78 80.79 9.66 42.33-.2 84.68-.73 127-.58 31.3.12 61.51 1.74 92.83-1.81A511.21 511.21 0 0 0 483.7 413Z",
    opacity: 0.25,
    transform: "translate(-3.09 -66.33)",
    style: {
      isolation: "isolate"
    },
    className: "color68e1fd svgShape"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "m494.98 63.82-12.55-8.37s-28 30-77.08 46.14c0 0 60.56 10.76 89.63-37.77Z",
    className: "color68e1fd svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m498.07 138-12.55-8.36s-28 30-77.08 46.14c0 .03 60.56 10.78 89.63-37.78Z",
    transform: "translate(-3.09 -66.33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "m518.35 62.6-12.55-8.37s-28 30-77.08 46.14c0 0 60.51 10.76 89.63-37.77Z",
    className: "color68e1fd svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m521.44 136.81-12.55-8.36s-28 30-77.08 46.14c0 0 60.51 10.75 89.63-37.78Z",
    transform: "translate(-3.09 -66.33)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M239.54 116.34c1.71 2.21 4.68 3 7.45 3.36a57.15 57.15 0 0 0 11.62.49 2.16 2.16 0 0 1 1.7.36c.68.68.17 1.83-.39 2.62a24.64 24.64 0 0 1-10.3 8.72c-4.22 1.74-9.31 1.71-13.12-.79-2.86-1.88-5.25-5.15-8.67-5.08a36.31 36.31 0 0 1-30.15 24.83c-2 .21-4.52 0-5.35-1.87a4.94 4.94 0 0 1-.31-1.92c-.18-8.89 2.57-17.56 5.39-26 1.26-3.77 2.57-7.61 5-10.77 5-6.63 13.92-8.77 21.88-8.07 3.45.3 6.09.9 8.76 3.12 3.86 3.24 3.64 7.33 6.49 11Z",
    className: "color68e1fd svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M242.63 182.67c1.71 2.21 4.68 3 7.45 3.36a57.15 57.15 0 0 0 11.62.49 2.16 2.16 0 0 1 1.7.36c.68.68.17 1.83-.39 2.62a24.64 24.64 0 0 1-10.3 8.72c-4.22 1.74-9.31 1.71-13.12-.79-2.86-1.88-5.25-5.15-8.67-5.08a36.31 36.31 0 0 1-30.15 24.83c-2 .21-4.52 0-5.35-1.87a4.94 4.94 0 0 1-.31-1.92c-.18-8.89 2.57-17.56 5.39-26 1.26-3.77 2.57-7.61 5-10.77 5-6.63 13.92-8.77 21.88-8.07 3.45.3 6.09.9 8.76 3.12 3.86 3.24 3.64 7.33 6.49 11Z",
    transform: "translate(-3.09 -66.33)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M242.63 182.67c1.71 2.21 4.68 3 7.45 3.36a57.15 57.15 0 0 0 11.62.49 2.16 2.16 0 0 1 1.7.36c.68.68.17 1.83-.39 2.62a24.64 24.64 0 0 1-10.3 8.72c-4.22 1.74-9.31 1.71-13.12-.79-2.86-1.88-5.25-5.15-8.67-5.08a36.31 36.31 0 0 1-30.15 24.83c-2 .21-4.52 0-5.35-1.87a4.94 4.94 0 0 1-.31-1.92c-.18-8.89 2.57-17.56 5.39-26 1.26-3.77 2.57-7.61 5-10.77 5-6.63 13.92-8.77 21.88-8.07 3.45.3 6.09.9 8.76 3.12 3.86 3.24 3.64 7.33 6.49 11Z",
    transform: "translate(-3.09 -66.33)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M434.58 100.85s-5.91-68.4-4-90c0 0-112.06 50.5-142.51 90s-174.68 67.32-174.68 67.32l308.73 1Z",
    className: "color68e1fd svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M437.67 167.18s-5.91-68.4-4-90c0 0-112.06 50.5-142.51 90S116.48 234.5 116.48 234.5l308.73 1Z",
    transform: "translate(-3.09 -66.33)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M431.81 166.7s-5.78-61.9-4-76.92c0 0-82.64 42-109.67 76.92S244 211.61 244 211.61s140.77-42.32 187.81-44.91Z",
    transform: "translate(-3.09 -66.33)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M167.12 168.17s196.28-63.72 252-65.48S523.43 58.5 523.43 58.5s37.23 110.71 32.06 153.09l-84 40.49-76 57.35Z",
    className: "color68e1fd svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M356.43 185.53c-1.1-4.52 4-7.26 7.71-5.37 4 2 5.9 7.36 7.73 11.1a52.88 52.88 0 0 0 18.78 21c1.71 1.1 3.94 2.11 5.68 1.06 1.51-5.59-2.08-11.1-4.27-16.46a35.24 35.24 0 0 1-2.58-15.22 12.68 12.68 0 0 1 1.56-6.09 5.6 5.6 0 0 1 5.31-2.81c3.19.48 4.71 4.11 5.63 7.2l6.91 23.17c.37 1.24.92 2.66 2.16 3s2.67-.71 3.66-1.73a29.43 29.43 0 0 0 5.78-7.4c3.75-7.77.12-16.87-.43-25.48-.08-1.29.07-2.85 1.22-3.42 1.65-.81 3.23 1.18 4 2.84q4 8.72 7.62 17.56a29.66 29.66 0 0 1 2.4 7.9c.35 3.19-.31 6.38-.84 9.54a121 121 0 0 0-1.59 25.57c.3 6.84 1.18 13.76-.13 20.48-.91 4.67-2.85 9.07-4.78 13.42L411 303.71c-1.31 3-2.69 6-5.16 8.08s-6.37 2.83-8.9.83l-.71-27.39c-.13-5.3-.27-10.6-.92-15.86-1.31-10.66-4.7-21-8.07-31.15-1.13-3.4-2.3-6.9-4.67-9.59-2.16-2.46-5.12-4-7.76-6a33.39 33.39 0 0 1-12.42-18c-1.27-4.64-1.55-9.59-3.62-13.93a27.44 27.44 0 0 1-2.34-5.17Z",
    transform: "translate(-3.09 -66.33)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M371.62 179.19c-.26-.34-.84 0-1 .36s-.17.89-.46 1.22a11.64 11.64 0 0 0-2.49-3.21 1.47 1.47 0 0 0-.62-.37c-.57-.12-1.08.49-1.09 1.08a3.07 3.07 0 0 0 .65 1.6 4.13 4.13 0 0 0-2-1.79 1.15 1.15 0 0 0-.54-.12c-.53.07-.74.76-.61 1.28a11.57 11.57 0 0 1 .52 1.5 3.92 3.92 0 0 0-1.53-1.52c-.61-.35-1.55-.43-1.87.2a1.51 1.51 0 0 0-.06.92 9.79 9.79 0 0 0 .67 2.24 6.46 6.46 0 0 0-1.55-2.15.69.69 0 0 0-.35-.2c-.42 0-.54.56-.46 1a10.47 10.47 0 0 0 4.62 6.87 12.73 12.73 0 0 1 2.64 1.81c.28.3.62.69 1 .57a1.17 1.17 0 0 0 .3-.19l3.61-2.89a.65.65 0 0 0 .25-.27c.11-.25-.08-.53-.23-.77a3.75 3.75 0 0 1-.13-3.52 14.4 14.4 0 0 0 .73-3.65Z",
    transform: "translate(-3.09 -66.33)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M422.92 169.61a3.38 3.38 0 0 1 .07-1.87 1.36 1.36 0 0 1 1.51-.87c.58.16.89.78 1.13 1.33l.8 1.87a9.74 9.74 0 0 1-1-2.93 1.6 1.6 0 0 1 .05-.92.62.62 0 0 1 .75-.38.83.83 0 0 1 .38.36 12.84 12.84 0 0 1 1.52 3 3.56 3.56 0 0 1-.61-2.88 1.08 1.08 0 0 1 .4-.68c.52-.32 1.12.25 1.43.77a11.67 11.67 0 0 1 1.16 2.72 6 6 0 0 1-.27-2.45 1 1 0 0 1 .29-.69c.44-.32 1 .21 1.26.68a12.65 12.65 0 0 1 1.49 7.36 3.11 3.11 0 0 1-.72 1.94 3.24 3.24 0 0 1-1.45.71 31.61 31.61 0 0 1-4.2.76 2.46 2.46 0 0 1-2.63-1l-1.53-1.44a1.05 1.05 0 0 1-.41-.72c0-.89 1.33-.53 1.6-1.2s-.94-2.8-1.02-3.47Z",
    transform: "translate(-3.09 -66.33)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M246.28 160.39c-4.26 13-10.33 14.1-15.69 10.39 0 0 0 .11-.07.31-.2.87-.84 3.24-1.94 3.94a3.63 3.63 0 0 1-1.92.56 6 6 0 0 1-5.2-3.64c-1.12-2.72-.59-5.81 0-8.7a40.93 40.93 0 0 1 2.18-8.32 20.89 20.89 0 0 1 10.08-10.63 11.25 11.25 0 0 1 5.21-1.29c3.25.14 8.24 3.18 9.2 6.5.77 2.82-.98 8.21-1.85 10.88Z",
    transform: "translate(-3.09 -66.33)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#8526fe",
    d: "M247.68 81.76c.1 1.92-.74 4.18-2.61 4.63-3.12.76-5.47-4-8.64-3.48-1.53.23-2.66 1.64-4.18 1.94-.81.17-1.67 0-2.47.2-1.41.37-2.28 1.79-2.81 3.15s-.9 2.86-1.93 3.9a2.52 2.52 0 0 1-.54-2 4 4 0 0 0-.22-2.11c-.34-.64-1.7-.62-2.23.54-1 1.87-.95 3.11-.64 5.21a1.44 1.44 0 0 1-2.08-.43 4.17 4.17 0 0 1-.47-2.34V84.3c0-2.19.07-4.63 1.6-6.19a8.63 8.63 0 0 1 2.15-1.42l2-1 2.43-1.26c3.1-1.57 6.42-3 9.89-2.92 5.03.06 10.46 5.09 10.75 10.25Z",
    className: "color3f3d56 svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M216.14 124.76c3 5.36 6.25 10.8 10.92 14.83 1.37 1.19 12.77 4.77 11.81 6.31-14 9.88-17.92 2.74-21.16 1.58s-4.68-6.3-7.44-8.35a41 41 0 0 1-5.51-4.67 22.32 22.32 0 0 1-5.6-19.08c.67-3.62 7-14.28 11.75-8.46 1.42 1.73.4 5.35.81 7.48.72 3.69 2.58 7.11 4.42 10.36Z",
    className: "color68e1fd svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M219.23 191.09c3 5.36 6.25 10.8 10.92 14.83 1.37 1.19 12.77 4.77 11.81 6.31-14 9.88-17.92 2.74-21.16 1.58s-4.68-6.3-7.44-8.35a41 41 0 0 1-5.51-4.67 22.32 22.32 0 0 1-5.6-19.08c.67-3.62 7-14.28 11.75-8.46 1.42 1.73.4 5.35.81 7.48.72 3.69 2.58 7.11 4.42 10.36Z",
    transform: "translate(-3.09 -66.33)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M277.24 179.81c1.92-1.93 4.63-3.48 6.73-5.21-2.05-1-6.5-.48-8.32.93-2.49 1.92-6 6-1.35 7.5 1.25.4 4.15.47 4.48-1.3.22-.99-.57-2.9-1.54-1.92Z",
    transform: "translate(-3.09 -66.33)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M133.01 199.4S5.76 200.73.72 178.96l-.15-1.65c1.16-23.5 112.82-9.14 112.82-9.14l112.64.61c-3 .12-5.74.25-8.32.4-59 3.49-105.36 1.87-164.32-1.78-8.43-.52-18.16-2.54-26.54-1.29-4 .6-16.15 4.06-17.27 7.95-.49 1.68 1 3.23 2.48 4.24 12.94 9 29.86 9.25 45.64 9.14 110.17-.76 215.45-.29 325.49-1-3.59-2.13-250.18 12.96-250.18 12.96Z",
    className: "color68e1fd svgShape"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M383.19 186.42c-110 .73-215.32.26-325.49 1-15.78.11-32.7-.12-45.64-9.14-1.44-1-3-2.56-2.48-4.24 1.12-3.87 13.33-7.37 17.27-7.93 8.38-1.25 18.11.77 26.54 1.29 59 3.65 105.35 5.27 164.32 1.78 2.58-.15 5.37-.28 8.32-.4l98.25.54 20.22.11h.11l18.26.1c10.57 9.99 16.73 14.78 20.32 16.89Z",
    className: "color68e1fd svgShape"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m391.44 254.78-255.34 11S8.85 267.06 3.81 245.29l-.15-1.65c1.16-23.5 112.82-9.14 112.82-9.14L366 235.86c10.57 10 16.73 14.78 20.32 16.89h4.89a.56.56 0 0 1 0 .07v.18Z",
    transform: "translate(-3.09 -66.33)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M391.82 254.76h-.38l-.24-1.76v-.13a.56.56 0 0 0 0-.07Z",
    transform: "translate(-3.09 -66.33)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeWidth: 1.12,
    d: "M.72 178.96a5.64 5.64 0 0 1-.15-1.65Z",
    className: "colorStroke000000 svgStroke"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M406.91 357.13s-300.29 34.92-366.69 7.47c0 0-27.05-7.08-28.88-31s4.66-32.42-2.25-62.49L.72 178.96c5 21.77 132.29 20.44 132.29 20.44l255.72-11s4.5 13.77 5.92 59.89c1.73 56 12.26 108.84 12.26 108.84Z",
    className: "color68e1fd svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M386.28 252.75c-110 .73-215.32.26-325.49 1-15.78.11-32.7-.12-45.64-9.14-1.44-1-3-2.56-2.48-4.24 1.12-3.87 13.33-7.37 17.27-7.93 8.38-1.25 18.11.77 26.54 1.29 59 3.65 105.35 5.27 164.32 1.78 2.58-.15 5.37-.28 8.32-.4 19.84-.77 46.84-.7 64.2-.4 11.39.2 22.71.68 34.05.94 6.72.15 13.46.23 20.22.11h.11c3.7-.06 11 0 18.16 0l.1.09c10.57 10 16.73 14.79 20.32 16.9Z",
    transform: "translate(-3.09 -66.33)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M5 258.71s4.3 16.16 84.58 19.21 295.16-9.44 296.22-12.2 11.65 0 11.65 0-10.27 26.4-11.65 46.84 12.73 94.66 12.73 98.91c0 0-253.4 31.5-332.26 14.95 0 0-39.23-12.32-52.24-34.86",
    transform: "translate(-3.09 -66.33)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1.91 192.38s4.3 16.16 84.58 19.21 293.6-11.57 293.6-11.57 4 25.79 2.62 46.23 12.73 94.66 12.73 98.91c0 0-253.4 31.5-332.26 14.95 0 0-39.23-12.32-52.24-34.86",
    className: "colorStrokeffffff svgStroke"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M116.48 251.4s94-1.69 152-27 103.18 28.47 103.18 28.47Z",
    transform: "translate(-3.09 -66.33)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m473.41 306.58-72.5 54.05L389.94 254l-.24-1.82V252a.56.56 0 0 0 0-.07h-4.89c-3.59-2.11-9.75-6.9-20.32-16.89l-.1-.09-.28-.26c-27.8-26.32-62.79-23.9-62.79-23.9l5.18-2.44a236.07 236.07 0 0 1 79.81-21.59Z",
    transform: "translate(-3.09 -66.33)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M315.27 211.61s27.67-10.48 51.15-16.24 107.93-7 151.1-52.35c0 0 26.84 88.68 29.66 111.76l3.94 13.51s-67.57 30.41-77.71 38.29-72.5 54.05-72.5 54.05L388.74 254.9l-12.89-9.61c-17.57-16.48-31.74-29.48-54.06-32.73Z",
    transform: "translate(-3.09 -66.33)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M386.28 252.75h4.89v.25c.09.67-.17 2.56-4.89-.25Z",
    transform: "translate(-3.09 -66.33)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M187.63 234.41s67.89-20.37 91.9-29 75.81-21.59 75.81-21.59l-100.23 32.29-57.78 18.65Z",
    transform: "translate(-3.09 -66.33)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M212.83 234.76s9.15-.82 12.1-1l73.91-27.45Z",
    transform: "translate(-3.09 -66.33)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M434.39 145.02a18.9 18.9 0 0 0 5-10.5c.41-4.21-1.58-8.23-3.09-12.19-1-2.59-1.78-5.25-2.72-7.86-.71-2-1.49-3.91-2.36-5.82a12.92 12.92 0 0 0-10 3.38c1.34 1.36 1.45 3.46 2 5.29.89 2.95 3.06 5.46 3.5 8.51.56 3.88-2 7.76-5.28 9.86a22.08 22.08 0 0 1-4.94 2.11 83.58 83.58 0 0 1-13.77 3.7 29.59 29.59 0 0 1-14.12-.93 40.13 40.13 0 0 1-6.22-2.94 27 27 0 0 1-4.13-2.64 23.57 23.57 0 0 1-5.61-7.45 60.86 60.86 0 0 1-3.44-7.87 54.6 54.6 0 0 1-6.72 6.27l5.31 12a41.43 41.43 0 0 0 2.12 4.34 43.13 43.13 0 0 0 13.2 13.59 36.11 36.11 0 0 1 5.55 4.09 21.17 21.17 0 0 1 4.09 6.34c5 11 6 23.3 8.09 35.19a12.45 12.45 0 0 0 1.95 5.47c1.29 1.68 3.3 2.61 5.23 3.47a20.86 20.86 0 0 0 5.31 1.82 15.5 15.5 0 0 0 5.71-.34 31.08 31.08 0 0 0 19.27-13.34 14.57 14.57 0 0 0 2.45-6c.42-3.33-.92-6.6-1.85-9.83-1.05-3.63-1.59-7.37-2.35-11.07-1.44-7-8.76-19.26-2.18-26.65Z",
    className: "color68e1fd svgShape"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M437.48 211.35a18.9 18.9 0 0 0 5-10.5c.41-4.21-1.58-8.23-3.09-12.19-1-2.59-1.78-5.25-2.72-7.86-.71-2-1.49-3.91-2.36-5.82a12.92 12.92 0 0 0-10 3.38c1.34 1.36 1.45 3.46 2 5.29.89 2.95 3.06 5.46 3.5 8.51.56 3.88-2 7.76-5.28 9.86a22.08 22.08 0 0 1-4.94 2.11 83.58 83.58 0 0 1-13.77 3.7 29.59 29.59 0 0 1-14.12-.93 40.13 40.13 0 0 1-6.22-2.94 27 27 0 0 1-4.13-2.64 23.57 23.57 0 0 1-5.61-7.45 60.86 60.86 0 0 1-3.44-7.87 54.6 54.6 0 0 1-6.72 6.27l5.31 12a41.43 41.43 0 0 0 2.12 4.34 43.13 43.13 0 0 0 13.2 13.59 36.11 36.11 0 0 1 5.55 4.09 21.17 21.17 0 0 1 4.09 6.34c5 11 6 23.3 8.09 35.19a12.45 12.45 0 0 0 1.95 5.47c1.29 1.68 3.3 2.61 5.23 3.47a20.86 20.86 0 0 0 5.31 1.82 15.5 15.5 0 0 0 5.71-.34 31.08 31.08 0 0 0 19.27-13.34 14.57 14.57 0 0 0 2.45-6c.42-3.33-.92-6.6-1.85-9.83-1.05-3.63-1.59-7.37-2.35-11.07-1.44-7-8.76-19.26-2.18-26.65Z",
    transform: "translate(-3.09 -66.33)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#5fe4d4",
    d: "M396.71 272.06a89.39 89.39 0 0 1-2.06-16c-.11-17.16 6.34-32 8.15-49.06 9.85 4.81 26.58.69 33.76-7.59 6.84 18.95 4.11 39.9 7.24 59.79 2.85 18.15 10.52 35.13 15.75 52.73a2.19 2.19 0 0 1-.42 2.12c-1.29 1.4-6.19 1.56-7.21.19-8.64-11.65-13.72-25.46-19.62-38.71s-9.54-27.71-8.89-42.2c-1.22-.55-2.47.66-3.23 1.75-7.91 11.48-10.6 25.91-10.07 39.84.44 11.65 3 23.09 5.9 34.4 1.42 5.49-5.61 9.25-9.24 4.89l-.08-.09c-2.63-3.28-7.9-31.07-9.98-42.06Z",
    className: "color68e1fd svgShape"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M462.22 380.36c-1 1-3.87 1.39-5.74.95a2.5 2.5 0 0 1-1.47-.76c-8.64-11.65-13.72-25.46-19.62-38.71s-9.54-27.71-8.89-42.2a1.59 1.59 0 0 0-1.35 0 5 5 0 0 0-1.86 1.72c-7.91 11.48-10.6 25.91-10.07 39.84.44 11.65 3 23.09 5.9 34.4 1.42 5.49-5.61 9.25-9.24 4.89l-.08-.09c-2.63-3.26-7.9-31.05-10-42a89.39 89.39 0 0 1-2.06-16c-.11-17.16 6.34-32 8.15-49.06 9.85 4.81 26.58.69 33.76-7.59 6.84 18.95 4.11 39.9 7.24 59.79 2.85 18.15 10.52 35.13 15.75 52.73a2.19 2.19 0 0 1-.42 2.09Z",
    transform: "translate(-3.09 -66.33)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#33233a",
    d: "M407.83 331.43a1.89 1.89 0 0 0 0 .67 1.71 1.71 0 0 0 1.51 1.12 6.17 6.17 0 0 0 5.09-1.83 14.64 14.64 0 0 0 3-4.69 30.38 30.38 0 0 0 2.46-7.65 1.15 1.15 0 0 0-.17-1 1.5 1.5 0 0 0-.75-.29c-2.76-.69-6.18-10-8.5-2.73-.77 2.45.25 5.11-.23 7.66-.57 2.98-1.92 5.73-2.41 8.74ZM456.35 317.9a4.56 4.56 0 0 1-.64 1.7c-1.46 2.69-3 5.56-2.78 8.61a1.49 1.49 0 0 0 .59 1.28 1.56 1.56 0 0 0 1.16 0 16.14 16.14 0 0 0 10.23-9.9c.28-.81.45-1.83-.19-2.41a3.34 3.34 0 0 0-.94-.48c-2.68-1.11-3.56-6-6.29-6.29-5.17-.55-.99 5.77-1.14 7.49Z",
    className: "color25233a svgShape"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M457.49 379.58a2.93 2.93 0 0 1-1 1.73 2.5 2.5 0 0 1-1.47-.76c-8.64-11.65-13.72-25.46-19.62-38.71s-9.54-27.71-8.89-42.2a1.59 1.59 0 0 0-1.35 0c1.72-1.63 4-2.67 5.28-5.22a2.37 2.37 0 0 1 .68-1 1.45 1.45 0 0 1 1.9.47 3.92 3.92 0 0 1 .62 2.05c.74 7.56-1 15.27.24 22.76a52.88 52.88 0 0 0 3.78 11.5q3.12 7.39 6.54 14.67c2.05 4.34 4.17 8.65 6 13.07 2.64 6.24 4.76 12.68 6.87 19.11a5.43 5.43 0 0 1 .42 2.53Z",
    transform: "translate(-3.09 -66.33)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m257.36 226.15-25.51-9s4.87-5.94 9.43-6c0 0 15 9.09 18 9.42a90.08 90.08 0 0 0 9.86 0 1.54 1.54 0 0 1-1.55 1.75 4.07 4.07 0 0 0-2.35.56s5.73 1.93 7.42 3.81 1.36 2.29 1.36 2.29l-2.58.47-.47.94-1.55.47-1.88-.42-1.31-.61a18.3 18.3 0 0 1-2.55-1.27c-.68-.56-5.43-.39-6.32-2.41Z",
    transform: "translate(-3.09 -66.33)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M398.72 189.13a12.62 12.62 0 0 0-.06 3.63 11.82 11.82 0 0 0 1.89 4.15 14.31 14.31 0 0 0 2.74 3.4 19.88 19.88 0 0 1 2.4 2 7.08 7.08 0 0 1 1.39 4.89 1.51 1.51 0 0 0 .12.76 1.12 1.12 0 0 0 .39.36 4 4 0 0 0 3.21.29 8.68 8.68 0 0 0 2.85-1.65 2 2 0 0 0 .65-.75 2.2 2.2 0 0 0 0-1.22c-.5-3.22.19-6.48.91-9.66s1.48-6.41 1.1-9.64-2.11-6.51-5.1-7.79a11.38 11.38 0 0 0-4.64-.71 10 10 0 0 0-3 .38c-4.83 1.54-4.4 7.48-4.85 11.56Z",
    transform: "translate(-3.09 -66.33)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#8526fe",
    d: "M399.64 105.13a3.21 3.21 0 0 0-1.31 0 1.8 1.8 0 0 0-1.18 2.19 1.31 1.31 0 0 0-2 0 2.24 2.24 0 0 0-.24 2.35c-.06-.19-.37-.17-.49 0a.85.85 0 0 0-.05.59l.14.89a14.08 14.08 0 0 0 .77 3.15c.91 2.18 2.85 3.73 4.81 5a4.18 4.18 0 0 1 1.36 1.21 3.54 3.54 0 0 1 .4 1.2 20.66 20.66 0 0 1 .36 3.85l1-1.76a.84.84 0 0 1 .31-.36c.33-.15.67.2.82.53a3.66 3.66 0 0 1-.15 3.33 9.2 9.2 0 0 0-.92 1.49 1.22 1.22 0 0 0 .46 1.52 5.27 5.27 0 0 0 .69.14 2.25 2.25 0 0 1 1.41 1.86 6.44 6.44 0 0 0 .67 2.35c.45.69 1.56 1 2.08.38.34.91 1.64.86 2.59.63a3.49 3.49 0 0 0 1.14-.43c.89-.62 1-1.86 1.17-2.93a28.56 28.56 0 0 1 1.37-4.48 34.79 34.79 0 0 0 1.64-7.61c.15-1.57.07-3.43-1.22-4.34a2.11 2.11 0 0 1-.71-.58 1.94 1.94 0 0 1 0-1.26c1.07-6.32-10.97-8.44-14.92-8.91Z",
    className: "color3f3d56 svgShape"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M230.52 171.09c-.2.87-.84 3.24-1.94 3.94a3.63 3.63 0 0 1-1.92.56 2.2 2.2 0 0 1-.61-1 4.74 4.74 0 0 1 .26-2.41 15.07 15.07 0 0 1 .9-2.34 2.19 2.19 0 0 1 .5-.7.84.84 0 0 1 .8-.21 1.45 1.45 0 0 1 .44.27 13.3 13.3 0 0 1 1.32 1.28 1.05 1.05 0 0 1 .25.61Z",
    transform: "translate(-3.09 -66.33)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M226.46 156.65a1.32 1.32 0 0 0 .12-.43c0-.27-.35-.41-.63-.44a.28.28 0 0 0-.18 0c-.08 0-.12.12-.16.2a5.94 5.94 0 0 0-.46 2.09 1.65 1.65 0 0 0 .13.91.65.65 0 0 0 .78.35 1 1 0 0 0 .38-.4 4.18 4.18 0 0 0 .43-.77c.14-.41.11-.21-.05-.5s-.53-.51-.36-1.01Z",
    transform: "translate(-3.09 -66.33)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "m382.19 351.63 9 52.93s-208.9 29.29-268.59 20.28c0 0 117.73-39.59 130.38-49.08s112.84-48.26 129.21-24.13Z",
    transform: "translate(-3.09 -66.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashOnWallet);
export default __webpack_public_path__ + "static/media/cash-on-wallet.addfa3fe1343e52c587309901341274c.svg";
export { ForwardRef as ReactComponent };